
export const LeaderboardEmpty = () => {
  return (
    <div className="text-center py-8 text-zinc-400">
      <p>No meditation sessions recorded yet.</p>
      <p className="mt-2">Be the first to join the leaderboard!</p>
    </div>
  );
};
